const semanticClassNames = {
  root: 'rich-content-viewer',
} as const;

export default semanticClassNames;
